const tablePage = {
    state: {
        pageNo: 1,
    },
    mutations: {
      CHANGE_CURRENT_PAGE: (state, currentPage) => {
        state.pageNo = currentPage;
      }
    },
    actions: {
    }
  }
  
  export default tablePage
  


// WEBPACK FOOTER //
// ./src/store/modules/tablePage.js